<div class="modulo">
    <app-header [tituloModulo]="titulo" [mostrarCrear]="true" [accion]="'ConsultarTodos'" [raiz]="'/docentes'" [regresar]="'/menu'"></app-header>
    <app-tablas [titulos]="titulos" [datos]="datos" [raiz]="'/docentes'" (eliminar)="eliminar($event)"></app-tablas>
  </div>
  
